var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { enterLibrary, unsetDocuments, zoomIn, zoomOut } from "./actions/libraryActions";
import DocumentsList from "./components/DocumentsList";
import { requestState } from "./helpers/requestState";
import LibraryLayout from "./LibraryLayout";
import { wrapDispatch } from "../Multireducer";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";

class Library extends RouteHandler {
  constructor(props, context) {
    super(props, context);
    this.superComponentWillReceiveProps = super.componentWillReceiveProps;

    const { dispatch } = context.store;
    wrapDispatch(dispatch, 'library')(enterLibrary());
    this.zoomIn = () => wrapDispatch(dispatch, 'library')(zoomIn());
    this.zoomOut = () => wrapDispatch(dispatch, 'library')(zoomOut());
    this.scrollCallback = this.scrollCallback.bind(this);
    this.state = { scrollCount: 0 };
  }

  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources);
  }

  urlHasChanged(nextProps) {
    const nextSearchParams = new URLSearchParams(nextProps.location.search);
    const currentSearchParams = new URLSearchParams(this.props.location.search);
    return nextSearchParams.get('q') !== currentSearchParams.get('q');
  }

  componentWillUnmount() {
    this.emptyState();
  }

  componentDidUpdate(prevProps) {
    if (this.urlHasChanged(prevProps)) {
      this.getClientState(this.props);
    }
  }

  emptyState() {
    wrapDispatch(this.context.store.dispatch, 'library')(unsetDocuments());
    actions.set('library.sidepanel.quickLabelState', {});
  }

  scrollCallback(event) {
    if (event.target.className.includes('document-viewer')) {
      this.setState((prevState, _props) => ({
        scrollCount: prevState.scrollCount + 1
      }));
    }
  }

  render() {
    trackPage();
    return /*#__PURE__*/(
      _jsx(LibraryLayout, {
        sidePanelMode: this.props.sidePanelMode,
        scrollCallback: this.scrollCallback,
        scrollCount: this.state.scrollCount }, void 0, /*#__PURE__*/

      _jsx(DocumentsList, {
        storeKey: "library",
        CollectionViewer: this.props.viewer,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        scrollCount: this.state.scrollCount }
      )
      ));

  }
}

const SSRLibrary = withRouter(Library);

export const LibraryCards = Object.assign(SSRLibrary, { requestState: Library.requestState });
export default Library;